import React from 'react'
import PropTypes from 'prop-types'
import ContentBox from '../../../layout/component/ContentBox'
import Column from '../../../bootstrap/component/Column'
import Row from '../../../bootstrap/component/Row'
import TeethSelect from './TeethSelect'
import LabelInput from '../../../form/component/LabelInput'
import TextArea from '../../../form/component/TextArea'


const AdditionalInstructions = ({ saveTreatmentPlan, treatmentPlan, readOnly, changeTreatmentPlan, changeDoNotMove, changeLeaveSpaceOpen }) => {
    const { doNotMove, leaveSpacesOpen } = treatmentPlan
    return (
        <div className="additional-instructions">
            <ContentBox title="Additional Instructions">
                <Row top="M">
                    <Column size={12}>
                        <h3>Do not move these teeth</h3>
                        <TeethSelect
                            isDoNotMove={true}
                            teeth={doNotMove}
                            readOnly={readOnly}
                            onChange={changeDoNotMove}
                            save={saveTreatmentPlan}/>

                    </Column>
                </Row>
                <Row top="M">
                    <Column size={12}>
                        <h3>Leave these spaces open</h3>
                        <TeethSelect
                            isDoNotMove={false}
                            teeth={leaveSpacesOpen}
                            readOnly={readOnly}
                            onChange={changeLeaveSpaceOpen}
                            save={saveTreatmentPlan}/>

                    </Column>
                </Row>
                <Row top="M">
                    <Column size={12}>
                        <LabelInput label="Additional Instructions">
                            <TextArea
                                name="additionalInstructions"
                                object={treatmentPlan}
                                readOnly={readOnly}
                                onBlur={saveTreatmentPlan}
                                onChange={changeTreatmentPlan}/>
                        </LabelInput>
                    </Column>
                </Row>
            </ContentBox>
        </div>
    )
}

AdditionalInstructions.propTypes = {
    treatmentPlan: PropTypes.object.isRequired,
    changeDoNotMove: PropTypes.func.isRequired,
    changeLeaveSpaceOpen: PropTypes.func.isRequired,
    changeTreatmentPlan: PropTypes.func.isRequired,
    saveTreatmentPlan: PropTypes.func.isRequired,
}


export default AdditionalInstructions



// WEBPACK FOOTER //
// ./src/modules/treatment/component/plan/AdditionalInstruction.js